module.exports = __webpack_public_path__ + "img/expanding-green.72c78ff5.svg";